<template>
    <div class="page">
        <ion-grid>
            <ion-row>
                <ion-col>
                    <div class="no-charger">
                        <h1>No Chager Associated</h1>
                        <ion-button>Add Charger</ion-button>
                    </div>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</template>

<script>
import { IonGrid, IonRow, IonCol, IonButton } from "@ionic/vue";
import { defineComponent } from "vue"

export default defineComponent ({
    name: 'myChargerHome',
    components: {
        IonGrid, IonRow, IonCol, IonButton
    },
    data() {
        return {

        }
    }
})
</script>

<style scoped>
.no-charger {
    margin: 50px auto;
    border: 1px solid black;
    text-align: center;
    padding: 20px;
    box-shadow: 2px 2px grey;
}
</style>